import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useNavigate } from "react-router-dom";
import { createQuestion } from "@/services/question";
import type { QuestionSettings } from "@/types/question";
import { mapToApiFormat } from "../utils/questionMappers";
import type {
	QuestionOption,
	QuestionTypeOrChecklist,
} from "./useQuestionForm";

type CreateQuestionParams = {
	title: string;
	selectedType: QuestionTypeOrChecklist;
	settings: QuestionSettings;
	options: QuestionOption[];
	description?: string;
};

export const useCreateQuestion = () => {
	const queryClient = useQueryClient();
	const navigate = useNavigate();

	return useMutation({
		mutationFn: async (params: CreateQuestionParams) => {
			const requestData = mapToApiFormat({
				title: params.title,
				selectedType: params.selectedType,
				settings: params.settings,
				options: params.options,
				description: params.description,
			});

			if (!requestData) {
				throw new Error("Erro ao preparar os dados da pergunta.");
			}

			return await createQuestion(requestData);
		},
		onSuccess: () => {
			queryClient.invalidateQueries({ queryKey: ["checklistQuestions"] });
			queryClient.invalidateQueries({ queryKey: ["questions"] });

			setTimeout(() => {
				navigate("/questions/list");
			}, 1500);
		},
	});
};
